/**
 * VENOR bundle comparison — routes both choices back to the one buy box.
 *
 * These cards do not add to the cart. Duplicating the add path would mean a
 * second place to keep the two-line add, the currency formatting and the
 * variant lookup correct, and would throw away the colour and size the shopper
 * already chose at the top of the page. Instead each button selects the matching
 * option in the picker and scrolls there, so the decision made down here is
 * carried into the control that already works.
 */
(function () {
  var section = document.querySelector('[data-vnb-pick]')?.closest('.vnb');
  if (!section) return;

  section.addEventListener('click', function (event) {
    var button = event.target.closest('[data-vnb-pick]');
    if (!button) return;

    var wanted = button.getAttribute('data-vnb-pick');
    var panel = document.querySelector('.vnp__panel:not([hidden])');
    var option = panel && panel.querySelector('[data-vnp-opt="' + wanted + '"]');

    /* The options only exist once the add-on has reported a variant. Without
       them there is nothing to select, so just take the shopper to the buy box
       and let them choose there. */
    if (option && !option.classList.contains('vnp__opt--on')) option.click();

    var target = document.querySelector('.vnp') || panel;
    if (!target) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    /* Move focus to the size row when no size is chosen yet, and to the add
       button when one is, so the keyboard lands on the next real decision
       rather than back at the top of a long section. */
    window.setTimeout(function () {
      var chosenSize = panel && panel.querySelector('[data-vnp-sizes]:not([hidden]) [aria-pressed="true"]');
      var next = chosenSize
        ? panel.querySelector('[data-vnp-add]')
        : panel && panel.querySelector('[data-vnp-sizes]:not([hidden]) button');
      if (next) next.focus({ preventScroll: true });
    }, reduced ? 0 : 500);
  });
})();
